import { defineStore } from 'pinia'

// TODO: refine type
type OnboardingUser = Record<string, unknown>

// TODO: refine type
type OnboardingBusiness = Record<string, unknown>

// TODO: refine type
type PendingVenue = Record<string, unknown> | null

export type OnboardingProfileType = 'B' | 'C' | null

interface OnboardingState {
  user: OnboardingUser
  profileType: OnboardingProfileType
  business: OnboardingBusiness
  forcedFullProcess: boolean
  isSignUpTabSelected: boolean
  activationDelay: number | null
  pendingVenue: PendingVenue
}

export const useOnboardingStore = defineStore('onboarding', {
  state: (): OnboardingState => ({
    user: {},
    profileType: null,
    business: {},
    forcedFullProcess: false,
    isSignUpTabSelected: false,
    activationDelay: null,
    pendingVenue: null,
  }),

  actions: {
    reset () {
      this.user = {}
      this.business = {}
      this.profileType = null
      this.forcedFullProcess = false
      this.isSignUpTabSelected = false
      this.activationDelay = null
      this.pendingVenue = null
    },

    setProfileType (profileType: OnboardingProfileType) {
      this.profileType = profileType
    },

    updateUser (data: Partial<OnboardingUser>) {
      Object.assign(this.user, data)
    },

    updateBusiness (data: Partial<OnboardingBusiness>) {
      Object.assign(this.business, data)
    },

    setPendingVenue (venue: PendingVenue) {
      this.pendingVenue = venue
    },

    clearPendingVenue () {
      this.pendingVenue = null
    },
  },
})
